export function DoubleDotVerticalIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='12' height='18' viewBox='0 0 12 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2 3C1.44772 3 1 2.55228 1 2C1 1.44772 1.44772 1 2 1C2.55228 1 3 1.44772 3 2C3 2.55228 2.55228 3 2 3Z'
        fill='currentColor'
      />
      <path
        d='M2 10C1.44771 10 1 9.55228 1 9C1 8.44772 1.44771 8 2 8C2.55228 8 3 8.44772 3 9C3 9.55228 2.55228 10 2 10Z'
        fill='currentColor'
      />
      <path
        d='M2 17C1.44771 17 0.999999 16.5523 0.999999 16C0.999999 15.4477 1.44771 15 2 15C2.55228 15 3 15.4477 3 16C3 16.5523 2.55228 17 2 17Z'
        fill='currentColor'
      />
      <path
        d='M2 2L2 2.01M2 9L2 9.01M2 16L2 16.01M2 3C1.44772 3 1 2.55228 1 2C1 1.44772 1.44772 1 2 1C2.55228 1 3 1.44772 3 2C3 2.55228 2.55228 3 2 3ZM2 10C1.44771 10 1 9.55228 1 9C1 8.44772 1.44771 8 2 8C2.55228 8 3 8.44772 3 9C3 9.55228 2.55228 10 2 10ZM2 17C1.44771 17 0.999999 16.5523 0.999999 16C0.999999 15.4477 1.44771 15 2 15C2.55228 15 3 15.4477 3 16C3 16.5523 2.55228 17 2 17Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 2L10 2.01M10 9L10 9.01M10 16L10 16.01M10 3C9.44772 3 9 2.55228 9 2C9 1.44772 9.44772 1 10 1C10.5523 1 11 1.44772 11 2C11 2.55228 10.5523 3 10 3ZM10 10C9.44771 10 9 9.55228 9 9C9 8.44772 9.44771 8 10 8C10.5523 8 11 8.44772 11 9C11 9.55228 10.5523 10 10 10ZM10 17C9.44771 17 9 16.5523 9 16C9 15.4477 9.44771 15 10 15C10.5523 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
